module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "long-term-wrapper"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.smallScreen),
      expression: "smallScreen"
    }]
  }, [_vm._v("Your device is too narrow to display this graphic. Please visit this page from a larger device or "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("go to the Compare Quarters view")]), _vm._v(".")], 1), _vm._v(" "), _c('map-controls', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.smallScreen),
      expression: "!smallScreen"
    }],
    attrs: {
      "grayscale": _vm.grayscale,
      "toggleScale": _vm.toggleScale,
      "state": _vm.state,
      "riskData": _vm.timeBlock
    }
  }), _vm._v(" "), _c('map-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.smallScreen),
      expression: "!smallScreen"
    }],
    attrs: {
      "timeBlock": _vm.timeBlock,
      "state": _vm.state
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60df839f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/long-term-map/LongTermMap.vue
// module id = 545
// module chunks = 1